import { render } from "./ClientSecondStep.vue?vue&type=template&id=790f0c50&scoped=true"
import script from "./ClientSecondStep.vue?vue&type=script&lang=js"
export * from "./ClientSecondStep.vue?vue&type=script&lang=js"

import "./ClientSecondStep.vue?vue&type=style&index=0&id=790f0c50&scoped=true&lang=css"

import exportComponent from "G:\\dev\\OSPanel\\domains\\arenda-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-790f0c50"]])

export default __exports__